import cx from 'classnames'
import Image, { StaticImageData } from 'next/image'
import React from 'react'

import BaseAnimation from '@/components/Common/Animation/BaseAnimation'

export type ImageProps = {
  image: StaticImageData
  alt: string
  parallax?: boolean
}
export default function VerticalSlideAnimation({
  children = <></>,
  // NOTE: 画面の下から10%の位置に来たら表示する
  rootMargin = '0px 0px -10% 0px',
  additionalClassNames = [],
  imageProps = null,
}: {
  children?: React.ReactNode
  threshold?: number
  rootMargin?: string
  additionalClassNames?: string[]
  imageProps?: ImageProps | null
}) {
  const wrap = imageProps
    ? (animationElement: React.ReactNode) => {
        return (
          <div
            className={cx('relative', ...additionalClassNames, 'align-bottom')}
            style={{ paddingBottom: `${100 * (imageProps.image.height / imageProps.image.width)}%` }}
          >
            {animationElement}
          </div>
        )
      }
    : (animationElement: React.ReactNode) => {
        return animationElement
      }

  return wrap(
    <BaseAnimation
      animationClassName={cx('animate-[vertical-slide_1s_cubic-bezier(.4,.15,.2,1)_both]')}
      rootMargin={rootMargin}
      once={true}
      isTransparent={true}
      invisible={true}
      additionalClassName={cx([
        ...additionalClassNames,
        {
          absolute: imageProps != null,
          'left-0': imageProps != null,
          'top-0': imageProps != null,
        },
      ])}
    >
      {imageProps ? (
        <Image
          src={imageProps.image.src}
          width={imageProps.image.width}
          height={imageProps.image.height}
          className={cx('w-full')}
          alt={imageProps.alt}
        />
      ) : (
        children
      )}
    </BaseAnimation>
  )
}
